// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LD2q","title":"styles_title__9p40y"};